

import React, { useState, useContext, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

import Select from "react-select";
import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";
import MenuDropdown from "./MenuDropdown";

//i18n
import { withTranslation } from "react-i18next";

//import images
import logoSm from "../../assets/images/moondance_logo_sm.png";
import logoDark from "../../assets/images/moondance_logo.png";
import logoLight from "../../assets/images/moondance_logo.png";
import PositionSelector from "../../moondance/lib/components/PositionSelector";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";

import { MoondanceContext } from '../../App';
import UseMoondanceApi from "../../moondance/lib/api";
import {groupAndSortPositions, buildAccountParameter,formatOptionLabel,formatGroupLabel, groupStyles} from "../../moondance/lib/formatData";

import MoondanceLayout from "../../moondance/lib/layout.js";

const Header = (props) => {

  const moondanceApi = UseMoondanceApi();
  const { darkMode } = useContext(MoondanceContext);
  const { accountList } = useContext(MoondanceContext);
  const { addAlert } = useContext(MoondanceContext);
  const { alertContent } = useContext(MoondanceContext);
  const { selectedStatus , setSelectedStatus } = useContext(MoondanceContext);
  const { selectedAccountList } = useContext(MoondanceContext);
  const [search, setsearch] = useState(false);
  const [PositionList, setPositionList] = useState(null);
  const navigate = useNavigate();

  const { lastUpdate, setLastUpdate } = useContext(MoondanceContext);
               
 
  useEffect(() => {

    async function fetchData() {
      var api_parameters = {
        account: buildAccountParameter(selectedAccountList),
        status: 'All',
      }
      if(accountList){
        try {
          moondanceApi.fetchPositionsList(api_parameters).then(response => {
            
            if(response.data.length > 0){
              setPositionList(groupAndSortPositions(response.data))
            }
          })
        } catch (error) {
          // console.log(error);
        }
      }
    }
    fetchData();
  }, [accountList,selectedAccountList, lastUpdate]);

  const customSelectPattern = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#0bb197' : 'white',
      color: state.isFocused ? 'white' : 'black',
    }),

  };
  function handleSelectPosition(p) {
    navigate(`/position/${p.value}`);

  }

  
  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <style>{`
        /* Unified dark surface for the topbar + dropdowns (matches the menu button) */
        /* Same brand gradient as the login background (tuned for a wide, thin bar). */
        #page-topbar {
          background-color:#2a3042 !important;
          background:
            radial-gradient(circle at 12% 50%, rgba(13,177,151,0.30), transparent 32%),
            radial-gradient(circle at 88% 50%, rgba(120,229,205,0.20), transparent 34%),
            linear-gradient(135deg, #1A1C27 0%, #232734 55%, #2a3042 100%) !important;
        }
        #page-topbar .navbar-header, #page-topbar .navbar-brand-box { background-color:transparent !important; }
        #page-topbar .header-item { color:#e9ecef !important; }
        #page-topbar .header-item:hover, #page-topbar .header-item:focus { color:#fff !important; }
        .app-dark-dropdown { background-color:#2a3042; border:none; box-shadow:0 4px 14px rgba(0,0,0,.4); padding:.4rem 0; }
        .app-dark-dropdown .dropdown-header { color:#a6b0cf; text-transform:uppercase; font-size:.7rem; letter-spacing:.04em; }
        .app-dark-dropdown .dropdown-divider { border-color:rgba(255,255,255,.12); }
        .app-dark-dropdown .dropdown-item { color:#e9ecef; }
        .app-dark-dropdown .dropdown-item:hover, .app-dark-dropdown .dropdown-item:focus { background-color:#3a4151; color:#fff; }
        .app-dark-dropdown .dropdown-item-text { color:#a6b0cf; }
      `}</style>
      <header id="page-topbar" className={(darkMode  ? 'darkMode' :'')} >
        <div  className={(darkMode  ? 'navbar-header darkMode' :'navbar-header')}>
          <div className={(darkMode  ? 'd-flex align-items-center darkMode' :'d-flex align-items-center')}>
            <MenuDropdown />
            <Link
              to="/dashboard/summary"
              className="d-lg-none"
              style={{
                color: '#fff',
                fontWeight: 700,
                fontSize: '1.1rem',
                letterSpacing: '-0.01em',
                marginLeft: '8px',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
              }}
            >
              Moondance
            </Link>
            <div className={(darkMode  ? 'navbar-brand-box text-center darkMode' :'navbar-brand-box text-center')}>
              <Link to="/dashboard/summary" className="logo logo-dark ">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="logo-dark" height="60" />
                </span>
              </Link>

              <Link to="/dashboard/summary" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-light" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="logo-light" height="60" />
                </span>
              </Link>
            </div>

            <form className="app-search d-none d-lg-block" style={{ minWidth: '25em' }}>
              { PositionList && PositionList.length >0 ?  (
                <div className="position-relative">
                <Select

                  onChange={(f) => {
                    handleSelectPosition(f);
                  }}
                  placeholder="Select Position"
                  options={PositionList}
                  classNamePrefix="select2-selection"
                  formatOptionLabel={formatOptionLabel}

                  formatGroupLabel={formatGroupLabel}
                               
                  styles={MoondanceLayout.select2customStyles}
                />
             </div>
              ):""}

            </form>
        
            
          </div>

          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="bx bx-search-alt" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                  { PositionList && PositionList.length >0 ?  (
                <div className="position-relative">
                <Select

                  onChange={(f) => {
                    handleSelectPosition(f);
                  }}
                  placeholder="Select Position"
                  options={PositionList}
                  classNamePrefix="select2-selection"
                  formatOptionLabel={formatOptionLabel}

                  formatGroupLabel={formatGroupLabel}
                               
                  styles={MoondanceLayout.select2customStyles}
                />
                
              </div>
              ):""}
                  </div>
                </form>
              </div>
            </div>

            <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >
        
            </div>
    
            <button
              type="button"
              onClick={() => {navigate('/addTransaction')}}
              style={{marginTop:'1em',marginBottom:'1em',maxWidth:'9em'}} className="hideOnMobile btn btn-sm btn-primary"
              ><i className="mdi mdi-cash"></i> Add Transaction
            </button>
            <button
              type="button"
              onClick={() => {navigate('/addNav')}}
              style={{marginLeft:'1em', marginTop:'1em',marginBottom:'1em',maxWidth:'9em'}} className="hideOnMobile btn btn-sm btn-primary"
              ><i className="mdi mdi-gold"></i> Update Nav
            </button>
          
            {(alertContent && alertContent.length > 0 ?<NotificationDropdown/> :'')}


            <ProfileMenu  />
          

          </div>
        </div>
        
        
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
/*
            <NotificationDropdown />*/